import { BankTransactionStatusFilter } from '@features/bankTransactions/enums/bankTransactionStatusFilter'
import { BankTransactionsFilters } from '@features/bankTransactions/types/bankTransactionsFilters'

import { PeriodMode } from '../../../../../../../../../enums/periodMode'
import { BankTransactionsEmptyStateVariant } from '../enums/bankTransactionsEmptyStateVariant'

export const getBankTransactionsEmptyStateVariant = (
  filters: Pick<
    BankTransactionsFilters,
    'statusFilter' | 'searchQuery' | 'minAmount' | 'maxAmount' | 'transactionTypeFilter' | 'period'
  >,
): BankTransactionsEmptyStateVariant => {
  const isDateFilterActive = filters.period && filters.period !== PeriodMode.All
  const hasActiveFilters =
    !!filters.searchQuery ||
    !!filters.minAmount ||
    !!filters.maxAmount ||
    !!filters.transactionTypeFilter ||
    isDateFilterActive

  if (hasActiveFilters) {
    return BankTransactionsEmptyStateVariant.NoFilterResults
  }

  if (filters.statusFilter === BankTransactionStatusFilter.ToReview) {
    return BankTransactionsEmptyStateVariant.ToReview
  }

  if (filters.statusFilter === BankTransactionStatusFilter.Reviewed) {
    return BankTransactionsEmptyStateVariant.Reviewed
  }

  return BankTransactionsEmptyStateVariant.General
}
